import { ConfigProvider } from 'antd'
import type { DefaultOptionType } from 'rc-tree-select/lib/TreeSelect'
import {
  type ITreeSelectDropdownProps,
  TreeSelectDropdown
} from '@jana-technology/lht-select-dropdown'

// import './selectDropdownWrapper.scss'

/**
 * Wrapper around Tree Select dropdown
 *
 * NOTE: For app specific customizations ONLY!
 * For addition of general/shared features, please try to
 * update the Tree Select component upstream.
 */
export const TreeSelectDropdownWrapper = <
  OptionType extends DefaultOptionType
>({
  className,
  ...props
}: ITreeSelectDropdownProps<OptionType>) => {
  return (
    <ConfigProvider
      theme={{
        token: {
          // borderRadius: 4
        }
      }}
    >
      <TreeSelectDropdown
        {...props}
        className={`select-dropdown-wrapper ${className}`}
      />
    </ConfigProvider>
  )
}
